import { call, put, takeEvery } from "redux-saga/effects";
import resources from "../../../config/resources";
import config from "../../../config/index";
import fetchService from "../../../lib/fetchService";
import { FIXED_MODEL_DATA_REQUEST, fixedModelDataError, fixedModelDataSuccess } from "./action";
import { handleSagaError } from "../../../dataproviders/errorResponseHandler";

const fixedModelDataSaga = function*({ payload }) {
  const { model, reason, message } = payload;

  const url = `${config.urls.BACKEND}/v2/${resources.MODELS}/${encodeURIComponent(model)}/fixedData`;
  const data = {};
  const body = { reason, message };

  try {
    const response = yield call(fetchService.post, url, data, body);

    for (const action of yield call(handleSagaError, response, fixedModelDataError)) {
      yield put(action);
      return;
    }

    if (response.ok) {
      const responseData = yield call(() => response.json());
      yield put(fixedModelDataSuccess(responseData));
    } else {
      const statusCode = response.status;
      yield put(fixedModelDataError(new Error(`Request failed with error ${statusCode}!`)));
    }
  } catch (e) {
    yield put(fixedModelDataError(e));
  }
};

export default function*() {
  yield takeEvery(FIXED_MODEL_DATA_REQUEST, fixedModelDataSaga);
}
